<template>

	<table class="table table-sm table-bordered table-striped" style="text-align: center">
		<thead>		
			<tr>
				<td>Estado </td>
				<td>Estado App </td>
				<td>Fecha alta </td>
				<td>Fecha entrega</td>
				<td>Fecha App</td>
			</tr>
		</thead>
		<tbody >
			<tr v-for="(item, i) in guia" :key="i">
			
				<td style="width:65px;">{{item.estado}}</td>
				<td style="width:70px;">{{item.estado_app}}</td>
				<td>
					<span v-if="item.alta">{{ $date(item.alta.date).format('DD/MM/YYYY HH:mm') }}</span>
				</td>
				<td >
					<span v-if="item.fchentrega">{{ $date(item.fchentrega.date).format('DD/MM/YYYY HH:mm') }}</span>
					
				</td>
				<td >
					<span v-if="item.fecha_app" >{{$date(item.fecha_app.date).format('DD/MM/YYYY HH:mm')}}</span>
				</td>
			</tr>
			<tr v-if="guia.length === 0">
					<td colspan="5">
						No se encontró información del estado de la guía.
					</td>
				</tr>
		</tbody>
	</table>

</template>

<script>

    export default {
        props: {
          guia: {
            required: true
            },
          },
        name:"estadoguia",
		created() {
			console.log('componente EstadoGuia', this.guia)
		}
       
    }
</script>

<style scoped>
	td {
		font-weight: 500 !important;
	}
</style>
